const LiveCleaningStatus = {
  running: "RUNNING",
  stop: "STOPPED",
  draft: "DRAFT"
};

export default LiveCleaningStatus;
